module.exports = __webpack_public_path__ + "img/pop_page_info_dormancy.6fd3531.svg";